module.exports = __webpack_public_path__ + "assets/img/store-reg-banner-04.d7cf4d78.png";